import { render, staticRenderFns } from "./PortfoliosToInvestPortfolioList.vue?vue&type=template&id=08456c0a&scoped=true&"
import script from "./PortfoliosToInvestPortfolioList.vue?vue&type=script&lang=ts&"
export * from "./PortfoliosToInvestPortfolioList.vue?vue&type=script&lang=ts&"
import style0 from "./PortfoliosToInvestPortfolioList.vue?vue&type=style&index=0&id=08456c0a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08456c0a",
  null
  
)

export default component.exports